import type { Product } from "./product-data";
import { SafeImage } from "@/components/common/SafeImage";
import { fallbackProductImage } from "@/lib/catalog/fallback-images";
import { ProductPrice } from "@/components/common/ProductPrice";
import { productImageAlt } from "@/lib/seo/schema";


export function ProductCard({ product }: { product: Product }) {
  return (
    <article className="group flex flex-col" style={{ fontFamily: "'Inter', sans-serif" }}>
      <div className="relative aspect-[4/5] overflow-hidden bg-[#faf7f2]">
        {product.badge && (
          <span className="absolute left-3 top-3 z-10 bg-white px-3 py-1 text-[10px] font-medium uppercase tracking-[0.24em] text-[#C6A15B]">
            {product.badge}
          </span>
        )}
        <SafeImage
          src={product.img}
          fallback={fallbackProductImage(product.slug || product.id)}
          alt={productImageAlt(product.name)}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-105"
        />
        <button
          type="button"
          className="absolute inset-x-0 bottom-0 translate-y-full bg-black py-3 text-[11px] font-medium uppercase tracking-[0.28em] text-white transition-transform duration-300 hover:bg-[#C6A15B] group-hover:translate-y-0"
        >
          Quick View
        </button>
      </div>
      <div className="mt-5 flex flex-col gap-1">
        <span className="text-[10px] uppercase tracking-[0.28em] text-black/40">
          {product.family}
        </span>
        <h3
          className="text-lg font-normal text-black"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          {product.name}
        </h3>
        <p className="text-xs text-black/50">{product.notes}</p>
        <ProductPrice 
          price={typeof product.price === 'number' ? product.price : parseFloat(String(product.price).replace(/[^0-9.]/g, ''))} 
          discountPercent={product.discountPercent} 
          prefix={product.prefix}
          size="sm"
        />
      </div>
    </article>
  );
}
